import { Box, Button, Chip, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { warningSoftStyles } from 'components/@home/@settings/Tabs/Agents/agenticThemeHelpers';
import FadeInOut from 'components/common/FadeInOut';
import { bool, func, object } from 'prop-types';
import React, { useMemo } from 'react';
import { I18n } from 'utils/i18n';

const getStyles = theme => ({
  footer: {
    flexShrink: 0,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  footerStatus: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minHeight: 32,
    flex: 1,
    minWidth: 0,
  },
  footerFeedback: {
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 500,
  },
  dirtyChip: {
    height: 20,
    fontSize: theme.typography.pxToRem(10.5),
    fontWeight: 600,
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
    ...warningSoftStyles(theme),
    border: 'none',
  },
});

const InstructionSaveFooter = ({ dirty, saving, saveFeedback, onSave, saveDisabled = false }) => {
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <Box component="footer" sx={styles.footer}>
      <Box sx={styles.footerStatus}>
        {dirty && (
          <Chip
            size="small"
            label={I18n.t('AgenticChatFlow.UnsavedChanges')}
            sx={styles.dirtyChip}
          />
        )}
        <FadeInOut show={Boolean(saveFeedback?.message)}>
          <Typography
            sx={[
              styles.footerFeedback,
              {
                color: saveFeedback?.severity === 'error' ? 'error.main' : 'success.main',
              },
            ]}
          >
            {saveFeedback?.message}
          </Typography>
        </FadeInOut>
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={onSave}
        disabled={saving || !dirty || saveDisabled}
        disableElevation
        sx={{ textTransform: 'none', borderRadius: '5px' }}
      >
        {I18n.t('AgenticChatFlow.Save')}
      </Button>
    </Box>
  );
};

InstructionSaveFooter.propTypes = {
  dirty: bool,
  saving: bool,
  saveFeedback: object,
  onSave: func.isRequired,
  saveDisabled: bool,
};

export default InstructionSaveFooter;
